module.exports = __webpack_public_path__ + "static/img/function4.5d017153.png";